import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetChargingSessionsPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/charging-sessions/get-charging-sessions-paginated.form-default-values';
import { GetChargingSessionsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/charging-sessions/get-charging-sessions-paginated.model';
import { useState } from 'react';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterEmspBoChargingSessionListContextProvider,
  useEmspBoChargingSessionListContext,
} from '../emsp-bo-charging-session.context';
import { EmspBoChargingSessionListFilterFormController } from './emsp-bo-charging-session-list-filter-form/emsp-bo-charging-session-list-filter-form.controller';

interface EmspBoChargingSessionListFilterControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const EmspBoChargingSessionListFilterController = ({
  onCancel,
  onSuccess,
}: EmspBoChargingSessionListFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useEmspBoChargingSessionListContext();
  const [multiStepFormState] = useState(MultiStepFormState.Default);

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetChargingSessionsPaginatedModel> = (
    errors,
  ) => {
    Logger.error(errors);
    toast.error(
      t('$.emsp-bo-charging-session-list-filter.error', {
        error: t('global.unknown'),
      }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<
    GetChargingSessionsPaginatedModel
  > = () => {
    setGetPaginatedQueryParameters((current) => {
      return {
        ...current,
      };
    });
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetChargingSessionsPaginatedDefaultValues(
    getPaginatedQueryParameters,
  );

  return (
    <FilterEmspBoChargingSessionListContextProvider data={data}>
      <EmspBoChargingSessionListFilterFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
        state={multiStepFormState}
      />
    </FilterEmspBoChargingSessionListContextProvider>
  );
};
